import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { TeleconsultaModel }
from '../../models/consult/teleconsulta.model';



import { ConsultRepository }
from '../../repositories/consult.repository';

export class
GetTeleconsultaByIdUseCase
implements UseCase<{ idAtencion: string },TeleconsultaModel> {

    constructor(private repository: ConsultRepository) {}

    execute(params: { idAtencion: string }):
    Observable<TeleconsultaModel> {

        return this.repository
            .getTeleconsultaById(
                params
            );
    }
}
